<template lang="pug">
.notification-section(v-if="hasTrending", :class="{ out: !notificationsShown }")
  .heading Notifications
  .toggler(@click="notificationsShown = !notificationsShown")
    span &raquo;
  .bg &nbsp;
  .notifications
    .search
      label
        .clearer(:class="{ hidden: !roboNotificationsFilter }", @click="roboNotificationsFilter = ''", :style="{ right: '0.7rem' }")
        input(placeholder="filter", v-model="roboNotificationsFilter")
    .filter-bar(:class="{ [`for-${ notificationFilter }s`]: notificationFilter }")
      .filter.all(@click="notificationFilter = null")
      .filter.videos(@click="notificationFilter = 'video'")
      .filter.tweets(@click="notificationFilter = 'tweet'")
      .filter.documents(@click="notificationFilter = 'document'")
    //- todo: order is changing due to network latency, order should match loadedFeedLps
    //-.notification.ready(v-for="(n{ t: title, pa: timestamp, dpa, d: desc, st, si, cid, type }, index) in notifications",
    .notification.ready(v-for="(n, index) in notifications")
      a.card(target="_blank",
             :class="{ [n.type]: true }",
             :href="n.type === 'tweet' && `https://twitter.com/user/status/${ n.id }`",
             @click="n.type === 'video' &&  play(n) || n.type === 'document' && openFolder(n)")
        .when {{ date(n.pa || n.dpa) | moment('from', 'now') }}
        .title(:title="n && n.t") {{ n && n.t }}
        .desc(:title="n && n.d") {{ n && n.d }}
        .details
          .source-image(:title="n.st", :style="{ 'background-image': (n.si || n.simgu || videoPubLogo(n)) && `url('${ n.si || n.simgu || videoPubLogo(n) }')` }")
</template>
<script>
import videos from '@/components/cheatsheet/videos';
import tweets from '@/components/cheatsheet/tweets';
import documents from '@/components/cheatsheet/documents';
//import quantile from '@/components/topo-components/quantile';
import { mapActions } from 'vuex';
import { vuexComputed, range } from '@/helpers';
export default {
  name: 'notifications',
  computed: {
    ...vuexComputed(
      'lazyLevel',
      'sharing',
      //'editing',
      'trending',
      'popupOpen',
      'notificationsShown',
      'notificationFilter',
      'currentVideo',
      'roboWeaveShown',
      'folderDoco',
      'insightsDoco',
      'insightsShown',
      'collapsed',
      'trendingVideos',
      'playlist',
      'backToRobo',
      'roboNotificationsFilter'
    ),
    hasTrending() {
      return this.$store.state.trending?.length;
    },
    notifications() {
      const { trending, notificationFilter } = this;
      return notificationFilter && trending.filter(({ type }) => type === notificationFilter) || trending;
    },
    editing() {
      return false;
    }
  },
  methods: {
    //...mapActions(['deleteFeed']),
    ...mapActions(['loadFolder', 'loadInsights', 'loadDoco']),
    play(id) {
      this.currentVideo = id;
      this.collapsed = false;
      this.playlist = this.trendingVideos;
    },
    date(ts) {
      return new Date(ts);
    },
    videoPubLogo({ ci }) {
      return (JSON.parse(ci || '{}') || {}).u;
    },
    random(max = 10) {
      return Math.round(Math.random() * max);
    },
    toggle(key) {
      const value = this.popupOpen !== key && key || null;
      this.popupOpen = value;
      if (value) {
        this.notificationsShown = false;
        console.log('34242', !this.notificationsShown);
      }
    },
    open(key) {
      return this.popupOpen === key;
    },
    async openFolder({ id, folderName }) {
      // open folder
      console.log('openFolder', folderName);
      await this.loadInsights({ id });
      //this.loadFolder(folderName);
      this.roboWeaveShown = this.notificationsShown = false;
      // open doc
      console.log('openFolder openInsights', id);
      //this.doco = id;
      this.folderDoco = id;
      this.insightsDoco = id;
      await (this.backToRobo = true);
      await this.loadDoco(id);
      await this.loadFolder(folderName);
      console.log('folderName', folderName);
      //await this.$store.dispatch('docoInsights', insights);
      // todo: fix for pdf not loading
      this.insightsShown = true;
      //this.loadDoco(id);
      //this.pdf = `https://d23xtmsrsmj88h.cloudfront.net/documents/${ id || 'no did' }-1.pdf`;
      console.log('openFolder openInsights done', id);
      window.history.pushState({ fromRobo: true }, 'Weave - folder view');
      console.log('state added from notifications');
    },
    items(url) {
      // todo: implement filter
      const feed = this.feeds.find(item => item.feed?.url === url);
      const { type, json, andOr, selectedTags = [], sources } = feed;
      //console.log('items', url, json, this.feeds);
      let r;
      if (json) {
        r = filter(json);
        //console.log('filtered by tag', r.length, json.length);
        r = r?.filter((item, index) => index < 12);
        if (r) {
          if (type === 'tweets') {
            r = r.map(({ id }) => id);
          } else if (type === 'documents') {
            r = r.map(({ did }) => did);
          }
        }
      }
      return r;
      function filter(r) {
        const st = selectedTags.reduce((map, item) => ({ ...map, [item]: 1 }), {});
        if (andOr === 'and') {
          selectedTags.forEach(tag => (r = r.filter(({ tags }) => tags[tag])));
        } else if (andOr === 'or') {
          if (selectedTags.length) {
            r = r.filter(({ tg }) => tg.some(t => st[t]));
          }
        } else {
          selectedTags.forEach(tag => (r = r.filter(({ tags }) => !tags[tag])));
        }
        const props = {
          duration: 'duq',
          age: 'ageq',
          sentiment: 'sentq',
          visuality: 'visq',
          interestingness: 'relq'
        };
        Object.keys(props).forEach(prop => {
          if (prop in feed) {
            let a = feed[prop];
            if (prop === 'duration') {
              a = a.map(q => q / 10);
            }
            const qs = quantiles(a);
            //console.log('qs', qs);
            r = r.filter(item => qs.includes(item[props[prop]]));
          }
        });
        if (Object.keys(sources || {}).length) {
          r = r.filter(({ st, ct }) => sources[st || ct]);
        }
        return r;
        function quantiles(array) {
          const [min, max] = array.map(v => v + 1);
          return range(min, max);
        }
      }
    }
  },
  components: { videos, tweets, documents/*, quantile*/ }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
$leftGutter: 4rem;
.notification-section {
  position: fixed;
  top: 4.4rem;
  right: 0;
  width: 24rem;
  z-index: 200;
  //border-left: 1px solid #ccc;
  //background-color: rgba(#fefefe, 1);
  height: calc(100vh - 6.25rem);
  padding-top: 2rem;
  will-change: transform;
  transition: transform 250ms ease-in-out;
  transform: translate3d(0, 0, 0);
  pointer-events: none;
  &.out {
    pointer-events: none;
    transform: translate3d(20rem, 0, 0);
    * {
      pointer-events: none !important;
    }
    & > .toggler {
      pointer-events: all !important;
      opacity: 0.75;
      //transform: translate3d(-15rem, 0, 0);
      & > span {
        transform: rotate(180deg);
      }
    }
  }
  & > .bg {
    position: fixed;
    top: 0;
    right: 0;
    width: 20rem;
    z-index: -1;
    border-left: 1px solid #ccc;
    background-color: rgba(#fefefe, 1);
    //background-color: rgba(green, 1);
    height: calc(100vh - 4.5rem);
  }
  & > .toggler {
    pointer-events: all;
    cursor: pointer;
    position: fixed;
    top: 1rem;
    right: calc(100% - 4rem);
    z-index: 2;
    margin-right: -1px;
    //transform: translate3d(-5.5rem, 0, 0);
    font-size: 2rem;
    padding: 0.25rem 0.125rem;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border: 1px solid #ccc;
    border-right-color: white;
    color: $brn;
    background-color: white;
    opacity: 1;
    transition: opacity 250ms ease-in-out 1500ms;
    will-change: opacity;
    &:hover {
      opacity: 1;
    }
    & > span {
      transform-origin: center;
      transition: transform 250ms ease-in-out;
      display: inline-block;
    }
  }
  .heading {
    position: absolute;
    top: 0;
    left: calc(50% + 3rem);
    width: 20rem;
    transform: translate3d(-50%, 0, 0);
    color: $brn;
    opacity: 1;
    font-weight: 200;
    font-size: 2rem;
  }
  .notifications {
    //padding-top: 6rem;
    /*display: grid;*/
    /*grid-template-columns: repeat(5, 20%);*/
    box-sizing: border-box;
    height: calc(100vh - 7rem);
    padding: 4.5rem 1rem 0;
    overflow: auto;
    pointer-events: all;
    & > .search {
      //position: absolute;
      //top: 1rem;
      //left: 5rem;
      label {
        position: relative;
        display: inline-block;
        padding: 0.5rem;
        input {
          line-height: 1.4rem;
          color: #8d6e4f;
          border: 1px solid #efefef;
          &:focus {
            border-color: #9a9a9a;
            outline: none;
          }
        }
      }
    }
    & > .filter-bar {
      position: absolute;
      top: 2rem;
      left: calc(50% + 3rem);
      transform: translate3d(-50%, 0, 0);
      z-index: 1;
      background-color: white;
      display: grid;
      grid-template-columns: repeat(4, 3.5rem);
      grid-column-gap: 1rem;
      height: 4.5rem;
      padding: 1rem 0.6rem;
      padding-bottom: 0;
      box-sizing: border-box;
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 60%;
        left: 0.6rem;
        box-sizing: border-box;
        border: 1px solid orange;
        box-shadow: 0 0 3px rgba(orange, 0.5);
        border-radius: 50%;
        transform: translate3d(0, -50%, 0);
        transition: transform 250ms ease-in-out;
        will-change: transform;
        width: 3.5rem;
        height: 3.5rem;
        z-index: 1;
        //pointer-events: none;
      }
      &.for-videos::before {
        transform: translate3d(4.5rem, -50%, 0);
      }
      &.for-tweets::before {
        transform: translate3d(9rem, -50%, 0);
      }
      &.for-documents::before {
        transform: translate3d(13.5rem, -50%, 0);
      }
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 60%;
        left: 1rem;
        right: 1rem;
        transform: translate3d(0, -50%, 0);
        height: 0.25rem;
        background-color: #eee;
        z-index: -1;
      }
      .filter {
        cursor: pointer;
        box-sizing: border-box;
        background: white center no-repeat;
        background-size: 80%;
        height: 100%;
        border: 3px solid #eee;
        border-radius: 50%;
        transform-origin: center;
        transition: transform 250ms ease-in-out;
        will-change: transform;
        &:hover {
          //transform: scale(1.2);
        }
        &.all,
        &.videos {
          background-image: url("data:image/svg+xml;charset%3Dutf8,%3Csvg height%3D'6.827in'  viewBox%3D'0 0 6.827 6.827' width%3D'6.827in' xmlns%3D'http://www.w3.org/2000/svg'%3E%3Cpath fill%3D'%238d6e4f' d%3D'M2.83373 4.08723c0.234571,-0.12152 0.468327,-0.242677 0.702075,-0.363862 0.229406,-0.118933 0.458823,-0.237913 0.689008,-0.357299 -0.255059,-0.133181 -0.508724,-0.265543 -0.762114,-0.397764 -0.209614,-0.109378 -0.419059,-0.218677 -0.628969,-0.328256l0 1.44718zm0.750823 -0.26928c-0.259551,0.134563 -0.51911,0.269091 -0.779783,0.404118l-0.0777087 0.040252 0 -0.0875433 0 -1.62249 0 -0.0877638 0.0779173 0.0406811c0.236012,0.123224 0.471343,0.246024 0.706886,0.368933 0.283362,0.147858 0.567059,0.295898 0.852677,0.445059l0.0905591 0.0472953 -0.0907677 0.0470787c-0.260673,0.135205 -0.520232,0.269819 -0.77978,0.404378z'/%3E%3Cpath fill%3D'%238d6e4f' d%3D'M5.83278 4.58511c-0.0327126,0.14115 -0.106701,0.263898 -0.20726,0.355248 -0.101142,0.091874 -0.229165,0.152126 -0.369209,0.16763 -0.305,0.0341142 -0.612587,0.0512874 -0.921185,0.0598937 -0.306618,0.00855118 -0.614535,0.00855118 -0.921929,0.00837402 -0.307256,0.000177165 -0.615177,0.000177165 -0.921839,-0.00837402 -0.308642,-0.0086063 -0.616319,-0.0257795 -0.921354,-0.0598937 -0.140071,-0.0155039 -0.268122,-0.0757756 -0.36922,-0.167677 -0.100508,-0.0913583 -0.174394,-0.214094 -0.206894,-0.355201 -0.0436378,-0.189098 -0.0654331,-0.386354 -0.0763071,-0.584752 -0.0109252,-0.199445 -0.0109291,-0.395992 -0.0109291,-0.586795 0,-0.191055 0.000279528,-0.387858 0.0114685,-0.587185 0.0111457,-0.198484 0.0332087,-0.395748 0.0768228,-0.584815 0.0323071,-0.141047 0.106157,-0.263748 0.206673,-0.35511 0.101157,-0.0919528 0.229335,-0.15226 0.369445,-0.167764 0.304996,-0.0341181 0.612673,-0.0512913 0.921315,-0.0599016 0.306665,-0.00855118 0.614587,-0.00855118 0.921799,-0.00837402 0.307256,-0.000177165 0.615197,-0.000177165 0.921823,0.00837402 0.308606,0.00861024 0.616193,0.0257835 0.921016,0.0599016 0.140244,0.0154961 0.268476,0.0757756 0.369728,0.167689 0.100626,0.0913504 0.174594,0.214075 0.207094,0.355185 0.0859488,0.37402 0.0859488,0.779492 0.0859409,1.16233l0.000208661 0 0 0.00967323 -0.000208661 0c1.5748e-005,0.192681 -7.48031e-005,0.391154 -0.0108425,0.586795 -0.0109134,0.19839 -0.0327126,0.395646 -0.0761575,0.584752zm-0.278929 0.2765c0.0849961,-0.0772126 0.147535,-0.180961 0.175181,-0.300248 0.0419449,-0.182579 0.0630433,-0.373945 0.0736535,-0.566839 0.0107638,-0.19563 0.0108543,-0.391161 0.0108425,-0.580961l-0.000208661 0 0 -0.00967323 0.000208661 0c3.93701e-006,-0.376594 7.87402e-006,-0.775457 -0.083437,-1.13858 -0.0274685,-0.119264 -0.0899803,-0.222992 -0.175016,-0.300185 -0.0849213,-0.0770866 -0.19235,-0.12763 -0.309728,-0.140602 -0.30328,-0.0339488 -0.607673,-0.0509882 -0.91226,-0.0594843 -0.306567,-0.00854724 -0.613094,-0.00854724 -0.918909,-0.00837402 -0.305772,-0.000173228 -0.61228,-0.000173228 -0.918886,0.00837402 -0.304618,0.00849606 -0.609102,0.0255394 -0.912559,0.0594843 -0.117224,0.0129724 -0.224587,0.0635433 -0.309445,0.140677 -0.0848898,0.0771614 -0.14728,0.180858 -0.174594,0.30011 -0.0421299,0.182626 -0.0634843,0.373984 -0.0743189,0.566902 -0.0107835,0.192075 -0.0110512,0.389496 -0.0110512,0.58135 0,0.191677 0,0.38913 0.0105118,0.580961 0.0105709,0.192882 0.0316654,0.384244 0.0738031,0.566839 0.0274724,0.119291 0.0899055,0.22302 0.174815,0.300201 0.0847992,0.0770866 0.192043,0.127618 0.30922,0.140591 0.303492,0.0339449 0.607976,0.0509843 0.912598,0.0594764 0.306602,0.00854724 0.61311,0.00854724 0.918925,0.00837402 0.305953,0.000173228 0.612457,0.000173228 0.919016,-0.00837402 0.304579,-0.00849213 0.608972,-0.0255354 0.912429,-0.0594764 0.117157,-0.0129724 0.224382,-0.0634882 0.309209,-0.140543z'/%3E%3C/svg%3E");
          &.all {
            position: relative;
            background-size: 45%;
            background-position: center 19%;
          }
        }
        &.all::before,
        &.all::after {
          position: absolute;
          top: 28%;
          left: 0;
          content: '';
          display: block;
          width: 2.5rem;
          height: 2.5rem;
          background: no-repeat center;
          background-size: 50%;
        }
        &.all::before,
        &.tweets {
          background-image: url("data:image/svg+xml;charset%3Dutf8,%3Csvg height%3D'6.827in' viewBox%3D'0 0 6.827 6.827' width%3D'6.8267in' xmlns%3D'http://www.w3.org/2000/svg'%3E%3Cpath fill%3D'%238d6e4f' d%3D'M5.71516 2.00822c-0.0389331,0.0132677 -0.0783937,0.0254291 -0.118327,0.0364173 -0.0986024,0.0271378 -0.199539,0.047185 -0.301929,0.0593189l3.93701e-006 4.72441e-005c-0.029248,0.00346457 -0.0557717,-0.017437 -0.0592362,-0.046685 -0.00272441,-0.0230118 0.0096378,-0.0443346 0.0292756,-0.0540709 0.097374,-0.0588268 0.183272,-0.134677 0.253878,-0.223484 0.0412283,-0.0518543 0.0771969,-0.108059 0.10715,-0.167811 -0.0603071,0.0300669 -0.122248,0.0572835 -0.185693,0.0814528 -0.108575,0.0413622 -0.221874,0.0739291 -0.339236,0.0967598l1.9685e-005 9.05512e-005c-0.0199449,0.00387795 -0.0394528,-0.00390551 -0.0514843,-0.0186024 -0.0877165,-0.0928819 -0.194453,-0.168228 -0.31376,-0.219843 -0.115772,-0.0500827 -0.243917,-0.0779488 -0.378563,-0.0779488 -0.262992,0 -0.501224,0.106732 -0.673697,0.279205 -0.172472,0.172472 -0.279205,0.410705 -0.279205,0.673697 0,0.0380236 0.00216535,0.0749055 0.00626378,0.110693 0.0042126,0.036815 0.0102992,0.0723858 0.0180236,0.106791l-0.051874 0.0116654 0.0520354 -0.011685c0.00645276,0.0287362 -0.0116142,0.0572677 -0.0403504,0.0637205 -0.00630315,0.00141732 -0.0125945,0.00164567 -0.0186496,0.000850394 -0.417823,-0.0216693 -0.811957,-0.130717 -1.16471,-0.309437 -0.342067,-0.173307 -0.645346,-0.412165 -0.893724,-0.70039 -0.0247559,0.0515669 -0.0449921,0.105925 -0.0602323,0.162476 -0.0213976,0.0794094 -0.0327717,0.163114 -0.0327717,0.249461 0,0.162433 0.040622,0.315421 0.112114,0.449024 0.0742126,0.138677 0.18174,0.256839 0.311685,0.343343l-0.029374 0.044374 0.0295551 -0.0443937c0.0245157,0.0163228 0.0311614,0.0494331 0.0148386,0.0739488 -0.0114843,0.017252 -0.0312874,0.0256535 -0.0505551,0.0234331 -0.0832638,-0.00254331 -0.163783,-0.0152244 -0.240732,-0.0364803 -0.0524134,-0.0144803 -0.103122,-0.0328819 -0.151886,-0.0547165 0.0155709,0.199669 0.0925827,0.382063 0.211996,0.528303 0.136929,0.167689 0.329496,0.287992 0.54902,0.33248l-0.0104173 0.0520827 0.0105945 -0.0522717c0.0288661,0.00585039 0.0475276,0.034 0.0416772,0.0628661 -0.00443701,0.0219016 -0.0217126,0.0379213 -0.0423976,0.0418268 -0.0428465,0.0112008 -0.0875984,0.0198661 -0.133677,0.0257992 -0.0472598,0.00608661 -0.0944724,0.00922835 -0.140984,0.00922835 -0.0323937,0 -0.0658189,-0.00157874 -0.100476,-0.00477559l-0.00855512 -0.000822835c0.0669016,0.15672 0.174461,0.291843 0.309437,0.392217 0.15437,0.114803 0.344535,0.184181 0.550669,0.188504l-0.00104331 0.053126 0.00111811 -0.0533228c0.0294488,0.000614173 0.0528189,0.0249921 0.0522047,0.0544409 -0.00038189,0.0183701 -0.0100157,0.034374 -0.0243543,0.0436654 -0.179189,0.139488 -0.381602,0.250185 -0.600252,0.325315 -0.212937,0.0731693 -0.441409,0.11285 -0.678988,0.11285 -0.00703937,0 -0.0141142,-3.54331e-005 -0.0212244,-0.000110236 0.16924,0.0907717 0.348531,0.164713 0.535803,0.219535 0.249906,0.0731614 0.514654,0.112429 0.789366,0.112429 0.835287,0 1.49626,-0.317878 1.96648,-0.78802 0.553079,-0.552996 0.843091,-1.3163 0.843091,-2.02111 0,-0.00111417 3.93701e-005,-0.00221654 0.000106299,-0.00331102l-0.00293701 -0.125835 -0.00019685 3.93701e-006c-0.000464567,-0.0199134 0.0100512,-0.0375394 0.0260197,-0.0470709 0.0947205,-0.0684606 0.183118,-0.145193 0.264181,-0.229161 0.0401102,-0.0415433 0.0784449,-0.0849488 0.114894,-0.130083zm-0.14624 -0.0660787c0.0936811,-0.0257795 0.184417,-0.0582244 0.271413,-0.0965512 0.0169606,-0.0096063 0.0385906,-0.00953543 0.0559134,0.00201181 0.0245039,0.0163346 0.031126,0.0494528 0.0147913,0.0739567 -0.0689488,0.103425 -0.147354,0.200638 -0.234102,0.290492 -0.0798701,0.0827323 -0.166756,0.158965 -0.25978,0.227783l0.0022874 0.0979961c0.000212598,0.00191732 0.000318898,0.00387008 0.000318898,0.00584646 0,0.73124 -0.300764,1.52303 -0.874343,2.09653 -0.488862,0.488783 -1.1753,0.819272 -2.04189,0.819272 -0.284134,0 -0.558843,-0.0408701 -0.818949,-0.11702 -0.268083,-0.0784843 -0.520016,-0.194339 -0.750201,-0.341421 -0.0183819,-0.0100787 -0.0298425,-0.0305394 -0.0273858,-0.0526654 0.00324803,-0.0292717 0.0296181,-0.050374 0.0588898,-0.047126l-1.1811e-005 9.44882e-005c0.0391024,0.00433858 0.0777992,0.00761417 0.116228,0.00977165 0.0374016,0.00209843 0.0764764,0.00317323 0.117484,0.00317323 0.22565,0 0.442476,-0.0376299 0.644406,-0.107016 0.164378,-0.0564843 0.318815,-0.133866 0.460059,-0.228992 -0.173213,-0.0273307 -0.332488,-0.0963346 -0.46715,-0.196484 -0.174291,-0.12961 -0.307461,-0.311378 -0.376433,-0.522402 -0.00389764,-0.00929921 -0.00520472,-0.019811 -0.00319685,-0.0304606 0.00546063,-0.0289449 0.0333543,-0.0479803 0.0622992,-0.0425197l-2.3622e-005 0.000133858c0.0302283,0.00570079 0.0599764,0.00988976 0.0893858,0.0126024 0.0286024,0.0026378 0.0588583,0.00394094 0.0908937,0.00394094 0.0105709,0 0.021063,-0.000161417 0.0314685,-0.000468504 -0.151374,-0.0681102 -0.284008,-0.170717 -0.38778,-0.297795 -0.149362,-0.182913 -0.239094,-0.416402 -0.239094,-0.67061l0 -0.0120157c-5.11811e-005,-0.00880709 0.00207874,-0.017748 0.00663386,-0.0260118 0.0142205,-0.0257913 0.0466614,-0.0351693 0.0724528,-0.0209488l-4.33071e-005 7.87402e-005c0.0663543,0.0365827 0.136929,0.0659488 0.210768,0.0863465 0.013248,0.00366142 0.0266102,0.0070315 0.0400748,0.0101181 -0.0785394,-0.0760709 -0.145417,-0.16439 -0.197571,-0.261846 -0.0797323,-0.149 -0.125035,-0.319055 -0.125035,-0.499024 0,-0.0955039 0.0126772,-0.188445 0.0365276,-0.276957 0.0240039,-0.0890748 0.0595157,-0.173748 0.104972,-0.25211 0.0032874,-0.0070315 0.00817323,-0.0134528 0.0145906,-0.018689 0.0228228,-0.0186181 0.0564213,-0.0152087 0.0750394,0.00761417l-0.0413268 0.0337126 0.041248 -0.0335394c0.247949,0.303972 0.557705,0.554799 0.91026,0.733421 0.322055,0.163165 0.67974,0.266063 1.05855,0.294193 -0.00262992,-0.0163071 -0.0048937,-0.0326457 -0.00676772,-0.0490118 -0.00464567,-0.0405591 -0.00709843,-0.0814921 -0.00709843,-0.12278 0,-0.292437 0.118677,-0.557335 0.310457,-0.749114 0.19178,-0.19178 0.456677,-0.310457 0.749114,-0.310457 0.148823,0 0.291252,0.0311457 0.42065,0.087122 0.124945,0.0540512 0.237256,0.131165 0.330988,0.225638 0.100929,-0.0211693 0.198925,-0.0501102 0.293472,-0.0861299 0.104539,-0.0398268 0.204583,-0.0882244 0.299496,-0.14426 0.0131339,-0.00885827 0.030063,-0.0117992 0.0462992,-0.00653937 0.0280197,0.00907874 0.0433701,0.0391614 0.0342913,0.0671811l-0.00015748 -5.11811e-005c-0.0400433,0.1235 -0.10152,0.236976 -0.180142,0.335862 -0.032374,0.0407205 -0.0676929,0.0790079 -0.105646,0.114543 0.0243583,-0.00569291 0.0485039,-0.0118386 0.0724094,-0.0184173z'/%3E%3C/svg%3E");
        }
        &.all::after,
        &.documents {
          background-image: url("data:image/svg+xml;charset%3Dutf8,%3C?xml version%3D'1.0' encoding%3D'UTF-8'?%3E%3Csvg xmlns%3D'http://www.w3.org/2000/svg' width%3D'100' height%3D'100'%3E%3Cstyle%3Epath { stroke: %238d6e4f; fill: %238d6e4f; stroke-width: 0.015 }%3C/style%3E%3Cpath d%3D'M83.012,17.5c0-0.527-0.271-0.99-0.682-1.258L66.477,2.637c-0.15-0.129-0.324-0.211-0.505-0.271C65.709,2.141,65.373,2,65,2 H18.5C17.671,2,17,2.671,17,3.5v93c0,0.828,0.671,1.5,1.5,1.5h63c0.828,0,1.5-0.672,1.5-1.5V18c0-0.067-0.011-0.13-0.02-0.195 C83.001,17.707,83.012,17.604,83.012,17.5z M20,95V5h44v12.5c0,0.829,0.672,1.5,1.5,1.5H80v76H20z'/%3E%3Cpath d%3D'M69,31H31c-0.552,0-1-0.448-1-1s0.448-1,1-1h38c0.553,0,1,0.448,1,1S69.553,31,69,31z'/%3E%3Cpath d%3D'M69,45H31c-0.552,0-1-0.448-1-1s0.448-1,1-1h38c0.553,0,1,0.448,1,1S69.553,45,69,45z'/%3E%3Cpath d%3D'M69,57H31c-0.552,0-1-0.447-1-1s0.448-1,1-1h38c0.553,0,1,0.447,1,1S69.553,57,69,57z'/%3E%3Cpath d%3D'M69,71H31c-0.552,0-1-0.447-1-1s0.448-1,1-1h38c0.553,0,1,0.447,1,1S69.553,71,69,71z'/%3E%3C/svg%3E");
          background-size: 50%;
        }
        &.all::after {
          left: 30%;
          background-size: 30%;
        }
      }
    }
    .notification {
      pointer-events: none;
      position: relative;
      width: 20rem;
      left: $leftGutter;
      &.ready {
        pointer-events: none;
        opacity: 1;
        a.card {
          pointer-events: all;
          cursor: pointer;
        }
        .bg {
          opacity: 1;
        }
      }
      a.card {
        cursor: pointer;
        display: block;
        text-decoration: none;
        color: inherit;
        position: relative;
        background-color: white;
        padding-top: 1.25rem;
        padding-bottom: 3.5rem;
        box-shadow: 1px 1px 3px #ccc;
        margin: 1rem;
        border-left: 1px solid $brn;
        border-radius: 0.25rem;
        //border-bottom-left-radius: 0.25rem;
        //opacity: 0.5;
        &::after {
          position: absolute;
          top: 0;
          left: 0.25rem;
          height: 3rem;
          width: 3rem;
          content: '\00a0';
          background-repeat: no-repeat;
          background-size: 50%;
        }
        &.video {
          &::after {
            background-image: url("data:image/svg+xml;charset%3Dutf8,%3Csvg height%3D'6.827in'  viewBox%3D'0 0 6.827 6.827' width%3D'6.827in' xmlns%3D'http://www.w3.org/2000/svg'%3E%3Cpath fill%3D'%238d6e4f' d%3D'M2.83373 4.08723c0.234571,-0.12152 0.468327,-0.242677 0.702075,-0.363862 0.229406,-0.118933 0.458823,-0.237913 0.689008,-0.357299 -0.255059,-0.133181 -0.508724,-0.265543 -0.762114,-0.397764 -0.209614,-0.109378 -0.419059,-0.218677 -0.628969,-0.328256l0 1.44718zm0.750823 -0.26928c-0.259551,0.134563 -0.51911,0.269091 -0.779783,0.404118l-0.0777087 0.040252 0 -0.0875433 0 -1.62249 0 -0.0877638 0.0779173 0.0406811c0.236012,0.123224 0.471343,0.246024 0.706886,0.368933 0.283362,0.147858 0.567059,0.295898 0.852677,0.445059l0.0905591 0.0472953 -0.0907677 0.0470787c-0.260673,0.135205 -0.520232,0.269819 -0.77978,0.404378z'/%3E%3Cpath fill%3D'%238d6e4f' d%3D'M5.83278 4.58511c-0.0327126,0.14115 -0.106701,0.263898 -0.20726,0.355248 -0.101142,0.091874 -0.229165,0.152126 -0.369209,0.16763 -0.305,0.0341142 -0.612587,0.0512874 -0.921185,0.0598937 -0.306618,0.00855118 -0.614535,0.00855118 -0.921929,0.00837402 -0.307256,0.000177165 -0.615177,0.000177165 -0.921839,-0.00837402 -0.308642,-0.0086063 -0.616319,-0.0257795 -0.921354,-0.0598937 -0.140071,-0.0155039 -0.268122,-0.0757756 -0.36922,-0.167677 -0.100508,-0.0913583 -0.174394,-0.214094 -0.206894,-0.355201 -0.0436378,-0.189098 -0.0654331,-0.386354 -0.0763071,-0.584752 -0.0109252,-0.199445 -0.0109291,-0.395992 -0.0109291,-0.586795 0,-0.191055 0.000279528,-0.387858 0.0114685,-0.587185 0.0111457,-0.198484 0.0332087,-0.395748 0.0768228,-0.584815 0.0323071,-0.141047 0.106157,-0.263748 0.206673,-0.35511 0.101157,-0.0919528 0.229335,-0.15226 0.369445,-0.167764 0.304996,-0.0341181 0.612673,-0.0512913 0.921315,-0.0599016 0.306665,-0.00855118 0.614587,-0.00855118 0.921799,-0.00837402 0.307256,-0.000177165 0.615197,-0.000177165 0.921823,0.00837402 0.308606,0.00861024 0.616193,0.0257835 0.921016,0.0599016 0.140244,0.0154961 0.268476,0.0757756 0.369728,0.167689 0.100626,0.0913504 0.174594,0.214075 0.207094,0.355185 0.0859488,0.37402 0.0859488,0.779492 0.0859409,1.16233l0.000208661 0 0 0.00967323 -0.000208661 0c1.5748e-005,0.192681 -7.48031e-005,0.391154 -0.0108425,0.586795 -0.0109134,0.19839 -0.0327126,0.395646 -0.0761575,0.584752zm-0.278929 0.2765c0.0849961,-0.0772126 0.147535,-0.180961 0.175181,-0.300248 0.0419449,-0.182579 0.0630433,-0.373945 0.0736535,-0.566839 0.0107638,-0.19563 0.0108543,-0.391161 0.0108425,-0.580961l-0.000208661 0 0 -0.00967323 0.000208661 0c3.93701e-006,-0.376594 7.87402e-006,-0.775457 -0.083437,-1.13858 -0.0274685,-0.119264 -0.0899803,-0.222992 -0.175016,-0.300185 -0.0849213,-0.0770866 -0.19235,-0.12763 -0.309728,-0.140602 -0.30328,-0.0339488 -0.607673,-0.0509882 -0.91226,-0.0594843 -0.306567,-0.00854724 -0.613094,-0.00854724 -0.918909,-0.00837402 -0.305772,-0.000173228 -0.61228,-0.000173228 -0.918886,0.00837402 -0.304618,0.00849606 -0.609102,0.0255394 -0.912559,0.0594843 -0.117224,0.0129724 -0.224587,0.0635433 -0.309445,0.140677 -0.0848898,0.0771614 -0.14728,0.180858 -0.174594,0.30011 -0.0421299,0.182626 -0.0634843,0.373984 -0.0743189,0.566902 -0.0107835,0.192075 -0.0110512,0.389496 -0.0110512,0.58135 0,0.191677 0,0.38913 0.0105118,0.580961 0.0105709,0.192882 0.0316654,0.384244 0.0738031,0.566839 0.0274724,0.119291 0.0899055,0.22302 0.174815,0.300201 0.0847992,0.0770866 0.192043,0.127618 0.30922,0.140591 0.303492,0.0339449 0.607976,0.0509843 0.912598,0.0594764 0.306602,0.00854724 0.61311,0.00854724 0.918925,0.00837402 0.305953,0.000173228 0.612457,0.000173228 0.919016,-0.00837402 0.304579,-0.00849213 0.608972,-0.0255354 0.912429,-0.0594764 0.117157,-0.0129724 0.224382,-0.0634882 0.309209,-0.140543z'/%3E%3C/svg%3E");
          }
        }
        &.tweet {
          &::after {
            background-image: url("data:image/svg+xml;charset%3Dutf8,%3Csvg height%3D'6.827in' viewBox%3D'0 0 6.827 6.827' width%3D'6.8267in' xmlns%3D'http://www.w3.org/2000/svg'%3E%3Cpath fill%3D'%238d6e4f' d%3D'M5.71516 2.00822c-0.0389331,0.0132677 -0.0783937,0.0254291 -0.118327,0.0364173 -0.0986024,0.0271378 -0.199539,0.047185 -0.301929,0.0593189l3.93701e-006 4.72441e-005c-0.029248,0.00346457 -0.0557717,-0.017437 -0.0592362,-0.046685 -0.00272441,-0.0230118 0.0096378,-0.0443346 0.0292756,-0.0540709 0.097374,-0.0588268 0.183272,-0.134677 0.253878,-0.223484 0.0412283,-0.0518543 0.0771969,-0.108059 0.10715,-0.167811 -0.0603071,0.0300669 -0.122248,0.0572835 -0.185693,0.0814528 -0.108575,0.0413622 -0.221874,0.0739291 -0.339236,0.0967598l1.9685e-005 9.05512e-005c-0.0199449,0.00387795 -0.0394528,-0.00390551 -0.0514843,-0.0186024 -0.0877165,-0.0928819 -0.194453,-0.168228 -0.31376,-0.219843 -0.115772,-0.0500827 -0.243917,-0.0779488 -0.378563,-0.0779488 -0.262992,0 -0.501224,0.106732 -0.673697,0.279205 -0.172472,0.172472 -0.279205,0.410705 -0.279205,0.673697 0,0.0380236 0.00216535,0.0749055 0.00626378,0.110693 0.0042126,0.036815 0.0102992,0.0723858 0.0180236,0.106791l-0.051874 0.0116654 0.0520354 -0.011685c0.00645276,0.0287362 -0.0116142,0.0572677 -0.0403504,0.0637205 -0.00630315,0.00141732 -0.0125945,0.00164567 -0.0186496,0.000850394 -0.417823,-0.0216693 -0.811957,-0.130717 -1.16471,-0.309437 -0.342067,-0.173307 -0.645346,-0.412165 -0.893724,-0.70039 -0.0247559,0.0515669 -0.0449921,0.105925 -0.0602323,0.162476 -0.0213976,0.0794094 -0.0327717,0.163114 -0.0327717,0.249461 0,0.162433 0.040622,0.315421 0.112114,0.449024 0.0742126,0.138677 0.18174,0.256839 0.311685,0.343343l-0.029374 0.044374 0.0295551 -0.0443937c0.0245157,0.0163228 0.0311614,0.0494331 0.0148386,0.0739488 -0.0114843,0.017252 -0.0312874,0.0256535 -0.0505551,0.0234331 -0.0832638,-0.00254331 -0.163783,-0.0152244 -0.240732,-0.0364803 -0.0524134,-0.0144803 -0.103122,-0.0328819 -0.151886,-0.0547165 0.0155709,0.199669 0.0925827,0.382063 0.211996,0.528303 0.136929,0.167689 0.329496,0.287992 0.54902,0.33248l-0.0104173 0.0520827 0.0105945 -0.0522717c0.0288661,0.00585039 0.0475276,0.034 0.0416772,0.0628661 -0.00443701,0.0219016 -0.0217126,0.0379213 -0.0423976,0.0418268 -0.0428465,0.0112008 -0.0875984,0.0198661 -0.133677,0.0257992 -0.0472598,0.00608661 -0.0944724,0.00922835 -0.140984,0.00922835 -0.0323937,0 -0.0658189,-0.00157874 -0.100476,-0.00477559l-0.00855512 -0.000822835c0.0669016,0.15672 0.174461,0.291843 0.309437,0.392217 0.15437,0.114803 0.344535,0.184181 0.550669,0.188504l-0.00104331 0.053126 0.00111811 -0.0533228c0.0294488,0.000614173 0.0528189,0.0249921 0.0522047,0.0544409 -0.00038189,0.0183701 -0.0100157,0.034374 -0.0243543,0.0436654 -0.179189,0.139488 -0.381602,0.250185 -0.600252,0.325315 -0.212937,0.0731693 -0.441409,0.11285 -0.678988,0.11285 -0.00703937,0 -0.0141142,-3.54331e-005 -0.0212244,-0.000110236 0.16924,0.0907717 0.348531,0.164713 0.535803,0.219535 0.249906,0.0731614 0.514654,0.112429 0.789366,0.112429 0.835287,0 1.49626,-0.317878 1.96648,-0.78802 0.553079,-0.552996 0.843091,-1.3163 0.843091,-2.02111 0,-0.00111417 3.93701e-005,-0.00221654 0.000106299,-0.00331102l-0.00293701 -0.125835 -0.00019685 3.93701e-006c-0.000464567,-0.0199134 0.0100512,-0.0375394 0.0260197,-0.0470709 0.0947205,-0.0684606 0.183118,-0.145193 0.264181,-0.229161 0.0401102,-0.0415433 0.0784449,-0.0849488 0.114894,-0.130083zm-0.14624 -0.0660787c0.0936811,-0.0257795 0.184417,-0.0582244 0.271413,-0.0965512 0.0169606,-0.0096063 0.0385906,-0.00953543 0.0559134,0.00201181 0.0245039,0.0163346 0.031126,0.0494528 0.0147913,0.0739567 -0.0689488,0.103425 -0.147354,0.200638 -0.234102,0.290492 -0.0798701,0.0827323 -0.166756,0.158965 -0.25978,0.227783l0.0022874 0.0979961c0.000212598,0.00191732 0.000318898,0.00387008 0.000318898,0.00584646 0,0.73124 -0.300764,1.52303 -0.874343,2.09653 -0.488862,0.488783 -1.1753,0.819272 -2.04189,0.819272 -0.284134,0 -0.558843,-0.0408701 -0.818949,-0.11702 -0.268083,-0.0784843 -0.520016,-0.194339 -0.750201,-0.341421 -0.0183819,-0.0100787 -0.0298425,-0.0305394 -0.0273858,-0.0526654 0.00324803,-0.0292717 0.0296181,-0.050374 0.0588898,-0.047126l-1.1811e-005 9.44882e-005c0.0391024,0.00433858 0.0777992,0.00761417 0.116228,0.00977165 0.0374016,0.00209843 0.0764764,0.00317323 0.117484,0.00317323 0.22565,0 0.442476,-0.0376299 0.644406,-0.107016 0.164378,-0.0564843 0.318815,-0.133866 0.460059,-0.228992 -0.173213,-0.0273307 -0.332488,-0.0963346 -0.46715,-0.196484 -0.174291,-0.12961 -0.307461,-0.311378 -0.376433,-0.522402 -0.00389764,-0.00929921 -0.00520472,-0.019811 -0.00319685,-0.0304606 0.00546063,-0.0289449 0.0333543,-0.0479803 0.0622992,-0.0425197l-2.3622e-005 0.000133858c0.0302283,0.00570079 0.0599764,0.00988976 0.0893858,0.0126024 0.0286024,0.0026378 0.0588583,0.00394094 0.0908937,0.00394094 0.0105709,0 0.021063,-0.000161417 0.0314685,-0.000468504 -0.151374,-0.0681102 -0.284008,-0.170717 -0.38778,-0.297795 -0.149362,-0.182913 -0.239094,-0.416402 -0.239094,-0.67061l0 -0.0120157c-5.11811e-005,-0.00880709 0.00207874,-0.017748 0.00663386,-0.0260118 0.0142205,-0.0257913 0.0466614,-0.0351693 0.0724528,-0.0209488l-4.33071e-005 7.87402e-005c0.0663543,0.0365827 0.136929,0.0659488 0.210768,0.0863465 0.013248,0.00366142 0.0266102,0.0070315 0.0400748,0.0101181 -0.0785394,-0.0760709 -0.145417,-0.16439 -0.197571,-0.261846 -0.0797323,-0.149 -0.125035,-0.319055 -0.125035,-0.499024 0,-0.0955039 0.0126772,-0.188445 0.0365276,-0.276957 0.0240039,-0.0890748 0.0595157,-0.173748 0.104972,-0.25211 0.0032874,-0.0070315 0.00817323,-0.0134528 0.0145906,-0.018689 0.0228228,-0.0186181 0.0564213,-0.0152087 0.0750394,0.00761417l-0.0413268 0.0337126 0.041248 -0.0335394c0.247949,0.303972 0.557705,0.554799 0.91026,0.733421 0.322055,0.163165 0.67974,0.266063 1.05855,0.294193 -0.00262992,-0.0163071 -0.0048937,-0.0326457 -0.00676772,-0.0490118 -0.00464567,-0.0405591 -0.00709843,-0.0814921 -0.00709843,-0.12278 0,-0.292437 0.118677,-0.557335 0.310457,-0.749114 0.19178,-0.19178 0.456677,-0.310457 0.749114,-0.310457 0.148823,0 0.291252,0.0311457 0.42065,0.087122 0.124945,0.0540512 0.237256,0.131165 0.330988,0.225638 0.100929,-0.0211693 0.198925,-0.0501102 0.293472,-0.0861299 0.104539,-0.0398268 0.204583,-0.0882244 0.299496,-0.14426 0.0131339,-0.00885827 0.030063,-0.0117992 0.0462992,-0.00653937 0.0280197,0.00907874 0.0433701,0.0391614 0.0342913,0.0671811l-0.00015748 -5.11811e-005c-0.0400433,0.1235 -0.10152,0.236976 -0.180142,0.335862 -0.032374,0.0407205 -0.0676929,0.0790079 -0.105646,0.114543 0.0243583,-0.00569291 0.0485039,-0.0118386 0.0724094,-0.0184173z'/%3E%3C/svg%3E");
          }
        }
        &.document {
          & > .title {
            font-weight: 300;
          }
          &::after {
            background-image: url("data:image/svg+xml;charset%3Dutf8,%3C?xml version%3D'1.0' encoding%3D'UTF-8'?%3E%3Csvg xmlns%3D'http://www.w3.org/2000/svg' width%3D'100' height%3D'100'%3E%3Cstyle%3Epath { stroke: %238d6e4f; fill: %238d6e4f; stroke-width: 0.015 }%3C/style%3E%3Cpath d%3D'M83.012,17.5c0-0.527-0.271-0.99-0.682-1.258L66.477,2.637c-0.15-0.129-0.324-0.211-0.505-0.271C65.709,2.141,65.373,2,65,2 H18.5C17.671,2,17,2.671,17,3.5v93c0,0.828,0.671,1.5,1.5,1.5h63c0.828,0,1.5-0.672,1.5-1.5V18c0-0.067-0.011-0.13-0.02-0.195 C83.001,17.707,83.012,17.604,83.012,17.5z M20,95V5h44v12.5c0,0.829,0.672,1.5,1.5,1.5H80v76H20z'/%3E%3Cpath d%3D'M69,31H31c-0.552,0-1-0.448-1-1s0.448-1,1-1h38c0.553,0,1,0.448,1,1S69.553,31,69,31z'/%3E%3Cpath d%3D'M69,45H31c-0.552,0-1-0.448-1-1s0.448-1,1-1h38c0.553,0,1,0.448,1,1S69.553,45,69,45z'/%3E%3Cpath d%3D'M69,57H31c-0.552,0-1-0.447-1-1s0.448-1,1-1h38c0.553,0,1,0.447,1,1S69.553,57,69,57z'/%3E%3Cpath d%3D'M69,71H31c-0.552,0-1-0.447-1-1s0.448-1,1-1h38c0.553,0,1,0.447,1,1S69.553,71,69,71z'/%3E%3C/svg%3E");
            background-size: 38%;
            top: 0.125rem;
            left: 0.4rem;
          }
        }
        &:hover > .when {
          color: black;
        }
        & > .when {
          position: absolute;
          top: 0;
          right: 0.125rem;
          white-space: nowrap;
          padding: 0.125rem;
          font-weight: 200;
          font-size: 0.8rem;
          color: $brn;
        }
        & > .desc {
          text-align: left;
          max-height: 3.5rem;
          padding: 0.125rem;
          padding-left: 0.5rem;
          overflow: hidden;
        }
        &:hover {
          & > .details {
            transform: translate3d(0, 0, 0);
          }
        }
        & > .details {
          //display: none;
          z-index: -1;
          position: absolute;
          right: 100%;
          top: 0.25rem;
          padding: 1rem;
          background-color: white;
          border: 1px solid #ccc;
          border-top-left-radius: 0.25rem;
          border-bottom-left-radius: 0.25rem;
          transform: translate3d(7rem, 0, 0);
          &:hover {
            transform: translate3d(0, 0, 0);
          }
          transition: transform 250ms ease-in-out 125ms;
          will-change: transform;
          .source-image {
            width: 2rem;
            height: 2rem;
            background: no-repeat center;
            background-size: contain;
          }
        }
        & > .loader {
          // background-color: rgba(255, 255, 255, 0.8);
          position: absolute !important;
          top: -35% !important;
          z-index: 5 !important;
          padding: 0 !important;
          transform: scale(0.45);
        }
        .popup {
          cursor: default;
          position: fixed;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 1000;
          overflow: auto;
          //transform: translate3d(0, -100%, 0);
          transform: translate3d(0, -1000vh, 0);
          transition: transform 400ms ease-in-out;
          will-change: transform;
          background-color: rgba(white, 0.95);
          &.open {
            transform: translate3d(0, 0, 0);
          }
          & > .close {
            position: absolute;
            top: 1rem;
            right: 1rem;
            font-size: 2.5rem;
            padding-top: 0;
            padding-left: 0.5rem;
            opacity: 0.7;
            will-change: opacity;
            transition: opacity 250ms ease-in-out;
            &:hover {
              opacity: 1;
            }
          }
          & > .title {
            margin-top: 1rem;
            margin-bottom: -1rem;
            @include pubTitle;
            font-size: 2rem;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          & > .query {
            display: block;
            text-decoration: none;
            color: inherit;
            margin-top: 1.5rem;
            margin-bottom: -1rem;
            display: flex;
            justify-content: center;
            .tags {
              .label {
                display: inline-block;
                opacity: 0.85;
                font-weight: 200;
                margin-right: 0.5rem;
              }
              .items {
                display: flex;
                justify-content: center;
                font-size: 0.8rem;
                & > * {
                  margin: 0.5rem;
                  padding: 0.125rem 0.5rem;
                }
                .tag {
                  border: 1px solid $brn;
                  border-radius: 3px;
                  position: relative;
                  color: $brn;
                  &:not(:last-of-type) {
                    margin-right: 2rem;
                    &::after {
                      content: attr(andOr);
                      position: absolute;
                      left: calc(100% + 1rem);
                      opacity: 0.85;
                      font-weight: 200;
                    }
                  }
                }
              }
            }
            .sources {
              display: flex;
              padding-top: 0.125rem;
              position: relative;
              .source {
                width: 2rem;
                height: 2rem;
                background: no-repeat center;
                background-size: contain;
                position: relative;
                &:not(:last-of-type) {
                  margin-right: 2rem;
                  &::after {
                    content: 'or';
                    position: absolute;
                    top: 0.5rem;
                    left: calc(100% + 0.5rem);
                    opacity: 0.85;
                    font-weight: 200;
                    font-size: 0.8rem;
                  }
                }
              }
            }
            .tags + .sources {
              margin-left: 4rem;
              &::before {
                content: 'and';
                position: absolute;
                top: 0.65rem;
                left: -3rem;
                opacity: 0.85;
                font-weight: 200;
                font-size: 0.8rem;
              }
            }
          }
          .quantiles {
            margin-left: 10rem;
            display: flex;
            & > * {
              margin: 0.5rem;
              margin-top: 0.965rem;
              width: 6rem;
              //padding-top: 0.25rem;
              // padding-left: 0;
              // padding-bottom: 0;
              font-size: 0.8rem;
              //border-bottom: 2px solid $brn;
              position: relative;
              color: $brn;
              // .line {
              //   position: absolute;
              //   top: 0%;
              //   width: 100%;
              //   height: 0.8rem;
              //   border: 1px solid $brn;
              //   //border-top-width: 0;
              //   border-radius: 3px;
              //   // border-bottom-left-radius: 3px;
              //   // border-bottom-right-radius: 3px;
              //   label {
              //     position: absolute;
              //     left: 50%;
              //     top: 0;
              //     width: 92%;
              //     transform: translate3d(-50%, -50%, 0);
              //     background-color: white;
              //     z-index: 1;
              //     border-top-left-radius: 3px;
              //     border-top-right-radius: 3px;
              //     padding-left: 0.25rem;
              //     padding-right: 0.25rem;
              //     border: 1px solid $brn;
              //   }
              //   .range {
              //     position: absolute;
              //     top: 0;
              //     height: 100%;
              //     background-color: $brn;
              //   }
              // }
              &.not::before {
                content: '\00a0';
                position: absolute;
                left: 0;
                bottom: -0.3rem;
                font-size: 0;
                height: 0.5rem;
                width: 2px;
                background-color: $brn;
              }
              &.not::after {
                content: '\00a0';
                position: absolute;
                right: 0;
                bottom: -0.3rem;
                font-size: 0;
                height: 0.5rem;
                width: 2px;
                background-color: $brn;
              }
              // background-color: green;
            }
          }
        }
        .bg {
          position: relative;
          padding-top: 120%;
          height: 100%;
          background: white no-repeat center;
          background-size: cover;
          overflow: hidden;
          opacity: 0.5;
          &::before {
            position: absolute;
            top: 0;
            right: 0;
            box-shadow: 0 0 3px #444;
            background-color: #fff;
            height: 4rem;
            width: 9rem;
            transform: rotate(45deg) translate3d(1.7rem,-2.2rem,0);
            transform-origin: center;
            content: "\00a0";
          }
          &::after {
            position: absolute;
            top: 0.25rem;
            right: 0.25rem;
            height: 3rem;
            width: 3rem;
            content: "\00a0";
            background-repeat: no-repeat;
            background-size: contain;
          }
        }
        & > .title {
          position: absolute;
          left: 0.5rem;
          bottom: 1rem;
          @include pubTitle;
          font-family: Assistant, Roboto, sans-serif;
          font-weight: 200;
          font-size: 1rem;
          right: 0.5rem;
          text-align: center;
        }
      }
    }
  }
}
</style>
